import {
  RemoteData,
  remoteDataError,
  remoteDataLoading,
  remoteDataNotFetched,
  remoteDataOK,
} from '@common/util-models';
import {
  SkyBasketItemQuoteDetails,
  SkyCreateQuoteResponse,
} from '@sky/util-models';

import { createReducer, on } from '@ngrx/store';
import * as QuotesActions from './quotes.actions';

export const QUOTES_FEATURE_KEY = 'quotes';

export interface QuotesState {
  quoteApiResult?: SkyCreateQuoteResponse;
  remoteState: RemoteData<null>;
  selectedQuote?: SkyBasketItemQuoteDetails;
}

export interface QuotesPartialState {
  readonly [QUOTES_FEATURE_KEY]: QuotesState;
}

export const initialState: QuotesState = {
  quoteApiResult: undefined,
  remoteState: remoteDataNotFetched(),
  selectedQuote: undefined,
};

export const quotesReducer = createReducer(
  initialState,
  on(QuotesActions.loadQuotes, (state) => ({
    ...state,
    remoteState: remoteDataLoading(),
  })),

  on(QuotesActions.loadQuotesSuccess, (state, { quoteApiResult }) => ({
    ...state,
    quoteApiResult,
    remoteState: remoteDataOK(null),
  })),

  on(QuotesActions.loadQuotesFailure, (state, { error }) => ({
    ...state,
    remoteState: remoteDataError(error),
  })),

  on(QuotesActions.selectQuote, (state, { quote }) => ({
    ...state,
    selectedQuote: quote,
  }))
);
